import { currentLanguage } from "../../common/ui/notify";

// Inline translation helper for the bidder-facing auction pages, matching the
// convention used by the admin auction screens. Usage: t("ქართული", "English",
// "Русский", "Հայերեն"). The site reloads on a language switch (see Header), so
// reading currentLanguage() at render time is enough — no extra re-render glue.
const ORDER = { geo: 0, en: 1, ru: 2, am: 3 };

export const t = (geo, en, ru, am) => {
    const i = ORDER[currentLanguage()] ?? 0;
    return [geo, en, ru, am][i] ?? geo;
};

export default t;
